import { Fragment, useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";

export const PlataformInformation = ({ detailsFormValues, isOld }) => {
  const { authorizationReport, authorizations } = useSelector(
    (state) => state.authorizationReport
  );
  const {
    subtotalExpenseAutorized,
    totalExpensePersonalAutorized,
    subtotalExpenseNotAutorized,
    taxISRPlataformsTechnologies,
    taxIVAPlataformsTechnologies,
  } = detailsFormValues;
  const { serviceAlienation, serviceGround, serviceLodging, totalIncomes } =
    taxISRPlataformsTechnologies;

  const [totalIsr, setTotalIsr] = useState(0.0);

  const considered =
    authorizations.paymentComplementExpensesSubtotal ||
    authorizationReport.paymentComplementExpensesSubtotal ||
    0;
  const consideredExpenseTotalAcreditable =
    parseFloat(subtotalExpenseAutorized) + parseFloat(considered);

  useEffect(() => {
    let totalIsr = (
      parseFloat(serviceAlienation.totalIsr) +
      parseFloat(serviceGround.totalIsr) +
      parseFloat(serviceLodging.totalIsr)
    ).toFixed(2);

    if (parseFloat(totalIsr) < 0) {
      totalIsr = 0.0;
    }
    setTotalIsr(totalIsr);
  }, [serviceAlienation, serviceGround, serviceLodging]);

  if (isOld) {
    return (
      <div className="col-md-6">
        <strong>Ingresos:</strong>
        <NumberFormat
          value={parseFloat(totalIncomes).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
        <br />
        <strong>Ingresos por Servicio Terrestre:</strong>
        <NumberFormat
          value={parseFloat(serviceGround?.totalService).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />{" "}
        <br />
        <strong>Ingresos por Servicio Hospedaje:</strong>
        <NumberFormat
          value={parseFloat(serviceLodging?.totalService).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />{" "}
        <br />
        <strong>Ingresos por Enajenación:</strong>
        <NumberFormat
          value={(
            parseFloat(serviceAlienation?.totalLendingPlataform) +
            parseFloat(serviceAlienation.totalAlienationPlataform)
          ).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
        <br />
        <strong>Deducciones Autorizadas:</strong>
        <NumberFormat
          value={parseFloat(consideredExpenseTotalAcreditable).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
        <br />
        <strong>Deducciones Personales:</strong>
        <NumberFormat
          value={parseFloat(totalExpensePersonalAutorized).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
        <br />
        <strong>No deducibles:</strong>
        <NumberFormat
          value={parseFloat(subtotalExpenseNotAutorized).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
        <br />
        {parseFloat(taxIVAPlataformsTechnologies.totalIva) >= 0 ? (
          <Fragment>
            <strong>Total a pagar de IVA:</strong>
            <NumberFormat
              value={parseFloat(taxIVAPlataformsTechnologies.totalIva).toFixed(
                2
              )}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
          </Fragment>
        ) : (
          <Fragment>
            <strong>Total a favor de IVA:</strong>
            <NumberFormat
              value={parseFloat(
                parseFloat(taxIVAPlataformsTechnologies.totalIva) * -1
              ).toFixed(6)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
          </Fragment>
        )}
        <strong>Total a pagar de ISR:</strong>
        <NumberFormat
          value={parseFloat(totalIsr).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
        <br />
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table
        className="table table-bordered table-sm mb-0"
        style={{ tableLayout: "auto", whiteSpace: "nowrap" }}
      >
        <thead className="thead-light">
          <tr>
            <th className="align-middle text-center" colSpan={2}>
              Valores de la plataforma
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="font-weight-bold">Ingresos</td>
            <td>
              <NumberFormat
                value={parseFloat(totalIncomes).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">Servicio Terrestre</td>
            <td>
              <NumberFormat
                value={parseFloat(serviceGround?.totalService).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">Servicio Hospedaje</td>
            <td>
              <NumberFormat
                value={parseFloat(serviceLodging?.totalService).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">Enajenación</td>
            <td>
              <NumberFormat
                value={(
                  parseFloat(serviceAlienation?.totalLendingPlataform) +
                  parseFloat(serviceAlienation.totalAlienationPlataform)
                ).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">Deducciones Autorizadas</td>
            <td>
              <NumberFormat
                value={parseFloat(consideredExpenseTotalAcreditable).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">Deducciones Personales</td>
            <td>
              <NumberFormat
                value={parseFloat(totalExpensePersonalAutorized).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">No deducibles</td>
            <td>
              <NumberFormat
                value={parseFloat(subtotalExpenseNotAutorized).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          <tr>
            {parseFloat(taxIVAPlataformsTechnologies.totalIva) >= 0 ? (
              <td>
                <span className="font-weight-bold">Total a pagar de IVA</span>
              </td>
            ) : (
              <td>
                <span className="font-weight-bold">Total a favor de IVA</span>
              </td>
            )}
            <td>
              {parseFloat(taxIVAPlataformsTechnologies.totalIva) >= 0 ? (
                <span>
                  <NumberFormat
                    value={parseFloat(
                      taxIVAPlataformsTechnologies.totalIva
                    ).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </span>
              ) : (
                <span>
                  <NumberFormat
                    value={(
                      parseFloat(taxIVAPlataformsTechnologies.totalIva) * -1
                    ).toFixed(6)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </span>
              )}
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">Total a pagar de ISR</td>
            <td>
              <NumberFormat
                value={parseFloat(totalIsr).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
